import PropTypes from 'prop-types';
import { Client } from './stompR';

let client = null;

export function notificationMonitor(props) {
  PropTypes.checkPropTypes(NotificationMonitorType, props, undefined, 'notificationMonitor');

  if (client === null) {
    client = new Client({
      onConnect: () => client.subscribe(props.topic),
      onMessage: props.dispatcher,
      debug: props.debug,
      brokerUrl: props.url
    });
  }

  return null;
}

const NotificationMonitorType = {
  dispatcher: PropTypes.func.isRequired,
  topic: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};
